<template>
  <div class="container-fluid">
    <a-row :gutter="[16, 16]">
      <a-col :span="19">
        <a-card style="width: 100%" :tab-list="tabList" :active-tab-key="activeKey" @tabChange="callback">
          <a slot="tabBarExtraContent" href="#">
            <a-range-picker :ranges="{
              Today: [moment().startOf('day'), moment().endOf('day')],
              'This Week': [moment().startOf('week'), moment().endOf('week')],
              'This Month': [
                moment().startOf('month'),
                moment().endOf('month'),
              ],
              'Last Three Months': [
                moment().subtract(3, 'months').startOf('month'),
                moment().endOf('month'),
              ],
            }" show-time :defaultValue="initDates" :format="dateFormat" @change="onChange" /></a>

          <!-- Parent Type Filter (only show for Parents tab) -->
          <div v-if="activeKey == '1'" style="
              margin-bottom: 16px;
              display: flex;
              gap: 16px;
              align-items: center;
            ">
            <span style="font-weight: 500">{{ $t("all.filterBy") }}</span>
            <a-radio-group v-model="parentTypeFilter" button-style="solid" @change="handleParentTypeFilterChange">
              <a-radio-button value="all">
                {{ $t("connected.all") }}
              </a-radio-button>
              <a-radio-button value="father">
                {{ $t("profil.father") }}
              </a-radio-button>
              <a-radio-button value="mother">
                {{ $t("profil.mother") }}
              </a-radio-button>
              <a-radio-button value="guardian">
                {{ $t("profil.guardian") }}
              </a-radio-button>
            </a-radio-group>
          </div>

          <main-stats :key="'M' + loadKey" :series="MainStatsData" :options="MainStatsoptions" class="row mw-100"
            v-if="MainStatsDataReady && noFilterOutgoing" />
          <div v-else class="card-body row mw-100">
            <a-spin />
          </div>
          <secondary-stats v-if="
            (activeKey == '1' || activeKey == '5') && secondaryStatsDataReady
          " :key="'S' + loadKey" :series="SecondaryStatsData" :options="SecondaryStatsOption" />
          <div v-else-if="activeKey == '1' || activeKey == '5'" class="card-body row mw-100">
            <a-spin />
          </div>
        </a-card>
      </a-col>
      <a-col :span="5">
        <connected-users v-if="activeKey == '1'" :key="'CU1' + loadKey" :loading="loadingInfo.parents"
          :users-list="filteredParentsList" :secondary-title="$t('liste.total')" :title="$t('sms.parents')"
          :messageEnabled="true" @updateSlected="updateSelected" @deleteSlected="deleteSelected">
        </connected-users>
        <connected-users v-else-if="activeKey == '5'" :key="'CU5' + loadKey" :loading="loadingInfo.teachers"
          :users-list="teachers_list" :secondary-title="$t('liste.total')" :title="$t('actualite.teachers')"
          :messageEnabled="false" @updateSlected="updateSelected" @deleteSlected="deleteSelected">
        </connected-users>
        <connected-users v-else-if="activeKey == '6'" :key="'CU6' + loadKey" :loading="loadingInfo.admins"
          :users-list="admins_list" :secondary-title="$t('liste.total')" :title="$t('connected.school_user')"
          :messageEnabled="false" @updateSlected="updateSelected" @deleteSlected="deleteSelected">
        </connected-users>
      </a-col>
      <a-col :span="24">
        <detailed-stats ref="detailedStats" :pagination="pagination" :search-text="searchText" :active-key="activeKey"
          :dates="dates" :selected-user="selectedUser" :parent-type-filter="parentTypeFilter"
          @change="handleTableChange" @search="handleSearchImmediate" @search-change="handleSearchChange" />
      </a-col>
    </a-row>
  </div>
</template>
<script>
/* eslint-disable */
import ConnectedUsers from "./components/ConnectedUsers";
import MainStats from "./components/MainStats";
import SecondaryStats from "./components/SecondaryStats";
import DetailedStats from "./components/DetailedStats";
import helpers from "./helpers";
import apiClient from "@/services/axios";
import moment from "moment";
import store from "store";
import _ from "lodash";
import tokenStorage from "@/services/tokenStorage";
function findOldestDate(dates) {
  return dates.reduce((oldest, current) => {
    return new Date(oldest) < new Date(current) ? oldest : current;
  });
}
export default {
  name: "UsersStats",
  components: {
    ConnectedUsers,
    MainStats,
    SecondaryStats,
    DetailedStats,
  },
  data() {
    return {
      tabList: [
        {
          key: "1",
          tab: this.$t("actualite.parents"),
        },
        {
          key: "5",
          tab: this.$t("actualite.teachers"),
        },
        {
          key: "6",
          tab: this.$t("connected.school_user"),
        },
      ],
      initDates: [moment().startOf("week"), moment().endOf("week")],
      dates: [moment().startOf("week"), moment().endOf("week")],
      dateFormat: "YYYY/MM/DD HH:mm",
      MainStatsDataReady: false,
      rawConnectedData: [],
      mainStatsChartData: [{ data: [] }],
      secondaryStatsDataReady: false,
      rawSecondaryData: [],
      activeKey: "1",
      selectedUser: "",
      parentTypeFilter: "all", // Filter for parent types: "all", "father", "mother", "guardian"
      loadKey: 0,
      loadingInfo: false,
      noFilterOutgoing: true,
      parents_list: [],
      fathers_list: [],
      mothers_list: [],
      guardians_list: [],
      teachers_list: [],
      admins_list: [],
      options: {
        mainStats: {},
        secondaryStats: {},
      },
      connectedAdmins: [],
      connectedParents: [],
      connectedTeachers: [],
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        showSizeChanger: true,
        showQuickJumper: true,
        showTotal: (total, range) =>
          this.$t("all.pagination.showTotal", {
            start: range[0],
            end: range[1],
            total: total,
          }),
        pageSizeOptions: ["10", "20", "50", "100"],
      },
      searchText: "",
    };
  },
  computed: {
    currentUserType() {
      if (this.activeKey == "1") {
        if (this.parentTypeFilter && this.parentTypeFilter !== "all") {
          return this.parentTypeFilter;
        }
        return "parent";
      } else if (this.activeKey == "5") return "teacher";
      else if (this.activeKey == "6") return "admin";
      return "parent";
    },
    filteredParentsList() {
      // Return the appropriate list based on parentTypeFilter
      if (this.activeKey !== "1") {
        return this.parents_list;
      }
      if (this.parentTypeFilter === "father") {
        return this.fathers_list;
      } else if (this.parentTypeFilter === "mother") {
        return this.mothers_list;
      } else if (this.parentTypeFilter === "guardian") {
        return this.guardians_list;
      }
      // Return all parents if filter is "all" or not set
      return this.parents_list;
    },
    filteredConnectedData() {
      this.noFilterOutgoing = false;
      let returns = undefined;
      if (this.MainStatsDataReady) {
        if (this.selectedUser == "") returns = this.rawConnectedData;
        else {
          const rawList = [...this.rawConnectedData]; // Reset filtering before applying new filter :: keep [...] copying to avoid infinit loop
          rawList.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
          returns = rawList.filter(
            (connectsItem) => connectsItem.user.id == this.selectedUser
          );
        }
      } else returns = [];
      this.noFilterOutgoing = true;
      return returns;
    },
    filteredawSecondaryData() {
      if (this.secondaryStatsDataReady) {
        if (this.selectedUser == "") return this.rawSecondaryData;
        else {
          const rawList = [...this.rawSecondaryData]; // Reset filtering before applying new filter :: keep [...] copying to avoid infinit loop
          const isParentType = this.activeKey == "1";
          return rawList.filter((seenItem) =>
            isParentType
              ? seenItem.parent == this.selectedUser
              : seenItem.teacher == this.selectedUser
          );
        }
      } else return [];
    },
    SecondaryDatalabels() {
      let labels = this.filteredawSecondaryData.map((item) => {
        const date = item.createdAt;
        return moment(date).format("DD MMMM yyyy");
      });
      return [...new Set(labels)];
    },
    MainStatsData() {
      return this.mainStatsChartData;
    },
    SecondaryStatsData() {
      return helpers.formatSecondaryData(
        this.filteredawSecondaryData,
        this.SecondaryDatalabels
      );
    },
    MainStatsoptions() {
      return helpers.MainStatsoptions(
        this.minDate,
        //this.selectedUserName == ""
        //  ? this.$t("stats.mainStats")
        //  : this.$t("stats.mainStatSelected", { name: this.selectedUserName }),
        this.$t("stats.mainStats"),
        this.$t("assiduite.date"),
        this.$t("stats.nb_connections"),
        this.$t("stats.connects")
      );
    },
    selectedUserName() {
      if (this.selectedUser == "") return "";
      else {
        const user = this.rawConnectedData.find(
          (userInfo) => userInfo.user.id == this.selectedUser
        );
        return user ? user.user.name : "";
      }
    },
    SecondaryStatsOption() {
      const isParentType = this.activeKey == "1";
      const secondaryStats = `stats.secondaryStats${isParentType ? "parent" : "teacher"
        }`;
      const secondaryStatSelected = `stats.secondaryStatSelected${isParentType ? "parent" : "teacher"
        }`;
      const seen = `stats.${isParentType ? "seen" : "published"}`;
      return helpers.SecondaryStatsOption(
        this.SecondaryDatalabels,
        this.selectedUserName == ""
          ? this.$t(secondaryStats)
          : this.$t(secondaryStatSelected, {
            name: this.selectedUserName,
          }),
        this.$t("assiduite.date"),
        this.$t("sms.newCourse"),
        this.$t(seen)
      );
    },
    minDate() {
      if (this.rawConnectedData.length == 0)
        return new Date("01 Jan 2023").getTime();
      else {
        const dates = this.rawConnectedData.map((fcd) => fcd.createdAt);
        const oldest = findOldestDate(dates)[0];
        return moment(new Date(oldest).getTime())
          .startOf("day")
          .format("YYYY-MM-DD");
      }
    },
    dateRanges() {
      return {
        [this.$t("all.dateRangeToday")]: [
          moment().startOf("day"),
          moment().endOf("day"),
        ],
        [this.$t("all.dateRangeThisWeek")]: [
          moment().startOf("week"),
          moment().endOf("week"),
        ],
        [this.$t("all.dateRangeThisMonth")]: [
          moment().startOf("month"),
          moment().endOf("month"),
        ],
        [this.$t("all.dateRangeLastThreeMonths")]: [
          moment().subtract(3, "months").startOf("month"),
          moment().endOf("month"),
        ],
      };
    },
  },
  async created() {
    this.loadingInfo = true;
    this.$socket.client.emit("connectedStatus", {
      token: tokenStorage.get(), // Get from in-memory storage
      db: store.get("DB"),
    });
    // parents
    this.$socket.client.on(
      "connectionList",
      async ({ admins, parents, teachers }) => {
        this.connectedAdmins = admins || [];
        this.connectedParents = parents || [];
        this.connectedTeachers = teachers || [];
        this.updateOnlineStatus();
        if (this.parents_list && this.parents_list.length > 0) {
          this.rebuildParentLists();
        }
      }
    );
    apiClient
      .post("/parents/filter", {
        query: { status: "active" },
        aggregation: [
          {
            $lookup: {
              from: "parentlogins",
              localField: "father.login",
              foreignField: "_id",
              as: "fatherLogin",
            },
          },
          {
            $lookup: {
              from: "parentlogins",
              localField: "mother.login",
              foreignField: "_id",
              as: "motherLogin",
            },
          },
          {
            $lookup: {
              from: "parentlogins",
              localField: "guardian.login",
              foreignField: "_id",
              as: "guardianLogin",
            },
          },
          {
            $project: {
              father: {
                firstName: 1,
                lastName: 1,
                login: { $arrayElemAt: ["$fatherLogin._id", 0] },
                photo: 1,
              },
              mother: {
                firstName: 1,
                lastName: 1,
                login: { $arrayElemAt: ["$motherLogin._id", 0] },
                photo: 1,
              },
              guardian: {
                firstName: 1,
                lastName: 1,
                login: { $arrayElemAt: ["$guardianLogin._id", 0] },
                photo: 1,
              },
              _id: 1,
            },
          },
        ],
      })
      .then(({ data }) => {
        const connectedLoginIds = new Set(
          (this.connectedParents || []).map((id) => String(id))
        );
        const isLoginConnected = (loginId) => {
          if (!loginId) return false;
          return connectedLoginIds.has(String(loginId));
        };
        this.parents_list = data.map((parent) => {
          let parentType = null;
          let firstName = "";
          let lastName = "";
          let loginId = null;
          let photo = null;
          if (parent.father?.login && isLoginConnected(parent.father.login)) {
            parentType = "father";
            firstName = parent.father.firstName || "";
            lastName = parent.father.lastName || "";
            loginId = parent.father.login;
            photo = parent?.father?.photo;
          } else if (
            parent.mother?.login &&
            isLoginConnected(parent.mother.login)
          ) {
            parentType = "mother";
            firstName = parent.mother.firstName || "";
            lastName = parent.mother.lastName || "";
            loginId = parent.mother.login;
            photo = parent?.mother?.photo;
          } else if (
            parent.guardian?.login &&
            isLoginConnected(parent.guardian.login)
          ) {
            parentType = "guardian";
            firstName = parent.guardian.firstName || "";
            lastName = parent.guardian.lastName || "";
            loginId = parent.guardian.login;
            photo = parent?.guardian?.photo;
          } else {
            // If none are connected, default to father if exists, else mother, else guardian
            if (
              parent.father &&
              (parent.father.firstName || parent.father.lastName)
            ) {
              parentType = "father";
              firstName = parent.father.firstName || "";
              lastName = parent.father.lastName || "";
              loginId = parent.father.login;
              photo = parent?.father?.photo;
            } else if (
              parent.mother &&
              (parent.mother.firstName || parent.mother.lastName)
            ) {
              parentType = "mother";
              firstName = parent.mother.firstName || "";
              lastName = parent.mother.lastName || "";
              loginId = parent.mother.login;
              photo = parent?.mother?.photo;
            } else if (
              parent.guardian &&
              (parent.guardian.firstName || parent.guardian.lastName)
            ) {
              parentType = "guardian";
              firstName = parent.guardian.firstName || "";
              lastName = parent.guardian.lastName || "";
              loginId = parent.guardian.login;
              photo = parent?.guardian?.photo;
            }
          }

          return {
            online: parentType !== null && isLoginConnected(loginId),
            firstName,
            lastName,
            photo: photo || null,
            _id: parent._id,
            type: parentType,
            loginId: loginId ? String(loginId) : null,
          };
        });

        this.fathers_list = data
          .filter(
            (parent) =>
              parent.father &&
              parent.father.login &&
              (parent.father.firstName || parent.father.lastName)
          )
          .map((parent) => ({
            online: isLoginConnected(parent.father.login),
            firstName: parent.father.firstName || "",
            lastName: parent.father.lastName || "",
            photo: parent.father?.photo || null,
            _id: parent._id,
            loginId: parent.father.login ? String(parent.father.login) : null,
          }));

        this.mothers_list = data
          .filter(
            (parent) =>
              parent.mother &&
              parent.mother.login &&
              (parent.mother.firstName || parent.mother.lastName)
          )
          .map((parent) => ({
            online: isLoginConnected(parent.mother.login),
            firstName: parent.mother.firstName || "",
            lastName: parent.mother.lastName || "",
            photo: parent.mother?.photo || null,
            _id: parent._id,
            loginId: parent.mother.login ? String(parent.mother.login) : null,
          }));

        this.guardians_list = data
          .filter(
            (parent) =>
              parent.guardian &&
              parent.guardian.login &&
              (parent.guardian.firstName || parent.guardian.lastName)
          )
          .map((parent) => ({
            online: isLoginConnected(parent.guardian.login),
            firstName: parent.guardian.firstName || "",
            lastName: parent.guardian.lastName || "",
            photo: parent.guardian?.photo || null,
            _id: parent._id,
            loginId: parent.guardian.login
              ? String(parent.guardian.login)
              : null,
          }));
      });

    // teachers
    apiClient
      .post("/teachers/filter", {
        query: { status: "active" },
        aggregation: [
          {
            $project: {
              employee: {
                firstName: 1,
                lastName: 1,
                photo: 1,
              },
              _id: 1,
            },
          },
        ],
      })
      .then(({ data }) => {
        this.teachers_list = data.map((teacher) => {
          let user = {
            online: this.connectedTeachers.includes(teacher._id),
            firstName: teacher.employee.firstName,
            lastName: teacher.employee.lastName,
            photo: teacher.employee.photo,
            _id: teacher._id,
          };
          return user;
        });
      });

    // admins
    apiClient
      .get("/autorisation/buildingUsers")
      .then((res) => {
        this.admins_list = res.data.reduce((toReturn, user) => {
          if (user.status === "active") {
            let firstName = "";
            let lastName = "";
            if (
              (user.firstName && user.firstName.length > 0) ||
              (user.lastName && user.lastName.length > 0)
            ) {
              firstName = user.firstName || "";
              lastName = (user.lastName || "") + ` (${user.userName})`;
            } else {
              firstName = this.$t("connected.noname");
              lastName = ` (${user.userName})`;
            }
            toReturn.push({
              online: this.connectedAdmins.includes(user._id),
              firstName,
              lastName,
              photo: user.avatar,
              _id: user._id,
            });
          }
          return toReturn;
        }, []);
      })
      .catch((e) => {
        console.log(e);
        this.$message.error(this.$t("error.aucUser"));
      });
    await this.updateConnectsData();
    await this.updateSecondaryData();
    this.loadingInfo = false;
  },
  methods: {
    moment,
    callback: async function (key) {
      this.activeKey = key;
      this.loadKey += 1;
      this.selectedUser = "";
      if (key !== "1") {
        this.parentTypeFilter = "all";
      }
      this.pagination.current = 1;
      await this.updateConnectsData();
      await this.updateSecondaryData();
    },
    handleParentTypeFilterChange() {
      this.selectedUser = "";
      this.pagination.current = 1;
      this.loadKey += 1;
      this.updateConnectsData();
      this.updateSecondaryData();
    },
    async deleteSelected() {
      this.selectedUser = "";
      this.pagination.current = 1; // Reset to first page when filter is cleared
      this.loadKey += 1; // Force chart re-render
      await this.updateConnectsData(); // Refresh chart data to show all users
    },
    updateSelected(value) {
      this.selectedUser = value;
      this.pagination.current = 1; // Reset to first page when user is selected
      this.updateConnectsData(value);
    },
    async updateConnectsData(selectedUserId = "") {
      this.MainStatsDataReady = false;
      const response = await helpers.fetchMainStats(
        this.currentUserType,
        selectedUserId,
        this.dates[0],
        this.dates[1],
        this.$message,
        this.$t
      );
      this.mainStatsChartData = response.chartData || [{ data: [] }];
      const dataUpdated = this.fixConnectedDataNames(response.rawData || []);
      this.rawConnectedData = [...dataUpdated];
      this.rawConnectedData.sort(
        (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
      );
      this.MainStatsDataReady = true;
    },
    handleSearchChange(value) {
      this.searchText = value;
      this.pagination.current = 1; // Reset to first page when search changes
    },
    handleSearchImmediate(value) {
      this.searchText = value;
      this.pagination.current = 1;
    },
    handleTableChange(pagination) {
      this.pagination.current = pagination.current;
      this.pagination.pageSize = pagination.pageSize;
    },
    async updateSecondaryData() {
      this.secondaryStatsDataReady = false;
      if (this.activeKey == "1" || this.activeKey == "5") {
        let data = await helpers.fetchSecondaryStats(
          this.currentUserType,
          "",
          this.dates[0],
          this.dates[1],
          this.$message,
          this.$t
        );
        if (this.activeKey == "5") {
          let temp = [];
          temp = data.courses.map((course) => ({
            ...course,
            fromCourse: course,
          }));
          temp = temp.concat(
            data.homeworks.map((homework) => ({
              ...homework,
              fromHomework: homework,
            }))
          );
          temp = temp.concat(
            data.quizes.map((quiz) => ({
              ...quiz,
              fromQuiz: quiz,
            }))
          );
          data = temp;
        }
        this.rawSecondaryData = [...data];
      }
      this.secondaryStatsDataReady = true;
    },
    fixConnectedDataNames(data) {
      let userList = [];
      if (this.activeKey == "1") userList = this.parents_list;
      if (this.activeKey == "5") userList = this.teachers_list;
      if (this.activeKey == "6") userList = this.admins_list;
      return data.map((elem) => {
        const user = userList.find((userInfo) => userInfo._id == elem.user.id);
        if (user)
          return {
            ...elem,
            user: {
              ...elem.user,
              name: user.firstName + " " + user.lastName,
            },
          };
        else return elem;
      });
    },
    async onChange(dates, dateStrings) {
      this.dates = dates;
      this.pagination.current = 1; // Reset to first page when date changes
      await this.updateConnectsData();
      await this.updateSecondaryData();
    },
    updateOnlineStatus() {
      // Convert connected IDs to Sets for faster lookup
      const connectedAdminsSet = new Set(
        (this.connectedAdmins || []).map((id) => String(id))
      );
      const connectedTeachersSet = new Set(
        (this.connectedTeachers || []).map((id) => String(id))
      );

      // Update admins and teachers (they use direct IDs)
      this.admins_list = this.admins_list.map((admin) => ({
        ...admin,
        online: connectedAdminsSet.has(String(admin._id)),
      }));
      this.teachers_list = this.teachers_list.map((teacher) => ({
        ...teacher,
        online: connectedTeachersSet.has(String(teacher._id)),
      }));

      // Parents are handled separately in rebuildParentLists() because they use login IDs
    },
    rebuildParentLists() {
      // This method updates online status for parent lists based on login IDs
      // It should be called after connectionList updates
      const connectedLoginIds = new Set(
        (this.connectedParents || []).map((id) => String(id))
      );

      const isLoginConnected = (loginId) => {
        if (!loginId) return false;
        return connectedLoginIds.has(String(loginId));
      };

      // Update parents_list online status using stored login IDs
      if (this.parents_list && this.parents_list.length > 0) {
        this.parents_list = this.parents_list.map((parent) => ({
          ...parent,
          online: parent.loginId ? isLoginConnected(parent.loginId) : false,
        }));
      }

      // Update fathers_list, mothers_list, and guardians_list
      if (this.fathers_list && this.fathers_list.length > 0) {
        this.fathers_list = this.fathers_list.map((father) => ({
          ...father,
          online: father.loginId ? isLoginConnected(father.loginId) : false,
        }));
      }

      if (this.mothers_list && this.mothers_list.length > 0) {
        this.mothers_list = this.mothers_list.map((mother) => ({
          ...mother,
          online: mother.loginId ? isLoginConnected(mother.loginId) : false,
        }));
      }

      if (this.guardians_list && this.guardians_list.length > 0) {
        this.guardians_list = this.guardians_list.map((guardian) => ({
          ...guardian,
          online: guardian.loginId ? isLoginConnected(guardian.loginId) : false,
        }));
      }
    },
  },
};
</script>
